import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    if (process.env.NODE_ENV !== 'production') {
      console.error('Render error:', error, info);
    }
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="container">
          <div className="content">
            <section className="section-card" style={{ padding: '2.5rem', textAlign: 'center' }}>
              <h1 style={{ color: '#f3f8ff', marginBottom: '0.8rem' }}>Something went wrong</h1>
              <p style={{ color: '#d5e5f8', lineHeight: 1.65, marginBottom: '1.2rem' }}>
                Please refresh the page. If the problem persists, contact info@aicity.com.au.
              </p>
              <button
                type="button"
                onClick={() => window.location.reload()}
                style={{
                  padding: '0.7rem 1.4rem',
                  borderRadius: '12px',
                  border: 0,
                  background: 'linear-gradient(130deg, #00a5b0, #1a7fc1)',
                  color: '#ffffff',
                  fontWeight: 700,
                  cursor: 'pointer',
                }}
              >
                Reload
              </button>
            </section>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
